import Image from 'next/image';
import tw, { styled } from 'twin.macro';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

import { ButtonV2, IconComponentType } from '@restworld/ui-ds';
import { customImageLoader, getAssetSrc } from '@restworld/utils-common';
import { Tooltip } from '@restworld/ui-ds-base';

function ShowcaseInfoCard({ button, content, image, isOffline }: ShowcaseInfoCardProps) {
  const { t } = useTranslation('restaurant-details-page');

  const ctaEl = useMemo(
    () => (
      <ButtonV2
        StartIcon={button.Icon}
        twStyle={tw`text-sm min-h-[32px] h-8 lg:(text-base min-h-[48px] h-12) `}
        fullwidth
        onClick={button.onClick}
        loading={button.loading}
        disabled={isOffline}
      >
        {button.text}
      </ButtonV2>
    ),
    [button.Icon, button.loading, button.onClick, button.text, isOffline]
  );

  return (
    <Wrapper>
      <div tw=" flex flex-col gap-4">
        <div tw="w-8 h-8 relative lg:(w-14 h-14)">
          <Image src={getAssetSrc(image)} loader={customImageLoader} alt="" fill />
        </div>
        {/* <Title fontSize="base" textColor="neutral-700" fontWeight="medium">
          {title}
        </Title> */}
        <p tw="text-neutral-700 text-base">{content}</p>
      </div>
      {isOffline ? (
        <Tooltip
          content={t('publish_your_showcase_to_get_access_to_this_feature')}
          theme={{
            target: 'w-full',
          }}
          placement="bottom"
        >
          {ctaEl}
        </Tooltip>
      ) : (
        ctaEl
      )}
    </Wrapper>
  );
}
export default ShowcaseInfoCard;

interface ShowcaseInfoCardProps {
  image: string;
  content: string;
  button: { text: string; onClick?: () => void; Icon: IconComponentType; loading?: boolean };
  isOffline?: boolean;
}

const Wrapper = styled.div<{ isOffline?: boolean }>`
  ${tw`p-6 pt-8 rounded-2xl bg-purple-50 border border-purple-700 flex flex-col gap-4 flex-1 md:(justify-between) lg:(justify-start)`}
`;
